/**
 * Created by Alex Aguilar on 7/5/2016.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .factory('tabService', [function () {

            var service = {
                getTabLegend: tabLegend,
                getTabAdminFlights: getTabAdminFlights,
                getTabOccupationCrew: getTabOccupationCrew,
                getTabAdminAirports: getTabAdminAirports,
                getTabAircrafts: getTabAircrafts,
                getTabBaseRates: getTabBaseRates,
                getCabinCategories: getCabinCategories,
                getTabRevenue: getTabRevenue,
                getTabParameter: getTabParameter,
                getTabManifestos: getTabManifestos,
                getTabAdminClassifications: getTabAdminClassifications,
                getTabAdminClassificationsSsr: getTabAdminClassificationsSsr,
                getTabStatistics: getTabStatistics,
                getTabPassagesTransaction: getTabPassagesTransaction,
                getTabLuggageTransaction: getTabLuggageTransaction,
                getTabSsrTransaction: getTabSsrTransaction,
                getTabCargoTransaction: getTabCargoTransaction,
                getTabClassAvailability: getTabClassAvailability,
                getTabPassengerList: getTabPassengerList,
                getTabCargoOperationReport: getTabCargoOperationReport,
                getTabCargoReceivedReport: getTabCargoReceivedReport,
                getTabLevelOfSalesReservations: getTabLevelOfSalesReservations,
                getTabReprint: getTabReprint,
                getTabPromotion: getTabPromotion,
                getTabCustomerCorporateReport: getTabCustomerCorporateReport,
                getTabProduction: getTabProduction,
                getTabPassages: getTabPassages,
                getTabAuditRegistration: getTabAuditRegistration
            };

            return service;

            function tabLegend(route) {
                var tabData = [
                    {'heading': 'global.menu.legendTab.legends', 'route': 'legends', 'active': false},
                    {'heading': 'global.menu.legendTab.seats', 'route': 'seats', 'active': false}
                ];

                return getTabs(tabData, route);
            }

            function getTabAdminFlights(route) {
                var tabData = [
                    {'heading': 'global.menu.adminFlightTab.adminFlight', 'route': 'adminFlights', 'active': false},
                    {'heading': 'global.menu.adminFlightTab.adminConnection', 'route': 'specialConnections', 'active': false},
                    {'heading': 'global.menu.adminFlightTab.generateFlight', 'route': 'generateFlights', 'active': false}
                ];
                return getTabs(tabData, route);
            }

            function getTabOccupationCrew(route) {
                var tabData = [
                    {'heading': 'global.menu.occupationCrewTab.commandCrew', 'route': 'airCrews', 'active': false},
                    {'heading': 'global.menu.occupationCrewTab.complementCrew', 'route': 'complementAirCrews', 'active': false},
                    {'heading': 'global.menu.occupationCrewTab.charge', 'route': 'occupationCrews', 'active': false}
                ];
                return getTabs(tabData, route);
            }

            function getTabAdminAirports(route){
                var tabData = [
                    {'heading': 'global.menu.adminAirportTab.countries', 'route': 'countries', 'active': false},
                    {'heading': 'global.menu.adminAirportTab.regions', 'route': 'regions', 'active': false},
                    {'heading': 'global.menu.adminAirportTab.cities', 'route': 'cities', 'active': false},
                    {'heading': 'global.menu.adminAirportTab.airports', 'route': 'airports', 'active': false}
                ];
                return getTabs(tabData, route);
            }

            function getTabAircrafts(route){
                var tabData = [
                    { 'heading': 'global.menu.aircraftTab.aircrafts', 'route': 'aircraftList', 'active': false },
                    { 'heading': 'global.menu.aircraftTab.seatMaps', 'route': 'structureSeatMaps', 'active': false },
                    { 'heading': 'global.menu.aircraftTab.modelAircrafts', 'route': 'modelAircrafts', 'active': false },
                    { 'heading': 'global.menu.aircraftTab.makers', 'route': 'makerList', 'active': false }
                ];
                return getTabs(tabData, route);
            }

            function getCabinCategories(){
                var categories = [
                    {code: "F", name: "air.category.firsClass", short: 'air.category.fC'},
                    {code: "C", name: "air.category.businessClass", short: 'air.category.bC'},
                    {code: "Y", name: "air.category.economyClass", short: 'air.category.eC'}
                ];
                return categories;
            }

            function getTabBaseRates(route){
                var tabData = [
                    { 'heading': 'global.menu.baseRatesTab.baseRatePassage', 'route': 'baseRatePassage', 'active': false },
                    { 'heading': 'global.menu.baseRatesTab.baseRateLuggage', 'route': 'baseRateLuggage', 'active': false},
                    { 'heading': 'global.menu.baseRatesTab.baseRateCargo', 'route': 'baseRateCargo', 'active': false }
                ];
                return getTabs(tabData, route);
            }

            function getTabs(tabs, route) {
                angular.forEach(tabs, function (tab) {
                    if (tab.route == route) {
                        tab.active = true;
                    } else {
                        tab.active = false;
                    }
                });
                return tabs;
            }

            function getTabRevenue(route) {
                var tabData = [
                    {'heading': 'global.menu.revenueTab.revenueProductionFlights', 'route': 'revenueProductionFlights', 'active': false},
                    {'heading': 'global.menu.revenueTab.revenueProductionConnections', 'route': 'revenueProductionConnections', 'active': false},
                    {'heading': 'global.menu.revenueTab.revenuePlanning', 'route': 'itineraryListRevenue', 'active': false},
                    {'heading': 'global.menu.revenueTab.revenueProductionFlightsSsr', 'route': 'revenueProductionFlightsSsr', 'active': false},
                    {'heading': 'global.menu.revenueTab.revenueProductionConnectionsSsr', 'route': 'revenueProductionConnectionsSsr', 'active': false},
                ];
                return getTabs(tabData, route);
            }

            function getTabParameter(route) {
                var tabData = [
                    {'heading': 'global.menu.parameterTab.flight', 'route': 'flightParameters', 'active': false},
                    {'heading': 'global.menu.parameterTab.saleReservation', 'route': 'saleReservationParameters', 'active': false},
                    {'heading': 'global.menu.parameterTab.checkIn', 'route': 'checkInParameters', 'active': false},
                    {'heading': 'global.menu.parameterTab.externalChannels', 'route': 'externalChannelsParameters', 'active': false},
                    {'heading': 'global.menu.parameterTab.noShow', 'route': 'noShowParameters', 'active': false}
                ];
                return getTabs(tabData, route);
            }

            function getTabManifestos(route) {
                var tabData = [
                    {'heading': 'global.menu.manifestTab.generalManifest', 'route': 'generalManifest', 'active': false},
                    {'heading': 'global.menu.manifestTab.passengerManifest', 'route': 'passengerManifest', 'active': false},
                    {'heading': 'global.menu.manifestTab.luggageManifest', 'route': 'luggageManifest', 'active': false},
                    {'heading': 'global.menu.manifestTab.cargoManifest', 'route': 'cargoManifest', 'active': false},
                    /*{'heading': 'global.menu.manifestTab.notocManifest', 'route': 'notocManifest', 'active': false},*/
                    {'heading': 'global.menu.manifestTab.ssrManifest', 'route': 'ssrRManifest', 'active': false},
                    {'heading': 'global.menu.manifestTab.paymentWeight', 'route': 'paymentWeight', 'active': false}
                ];
                return getTabs(tabData, route);
            }

            function getTabAdminClassifications(route) {
                var tabData = [
                    {'heading': 'global.menu.adminClassificationTab.classification', 'route': 'classifications', 'active': false},
                    {'heading': 'global.menu.adminClassificationTab.subClassification', 'route': 'subClassifications', 'active': false},
                    {'heading': 'global.menu.adminClassificationTab.item', 'route': 'items', 'active': false}
                ];
                return getTabs(tabData, route);
            }

            function getTabAdminClassificationsSsr(route) {
                var tabData = [
                    {'heading': 'global.menu.adminClassificationTabSsr.classification', 'route': 'settingSsr', 'active': false},
                    {'heading': 'global.menu.adminClassificationTabSsr.subClassification', 'route': 'subClassificationsSsr', 'active': false},
                    {'heading': 'global.menu.adminClassificationTabSsr.ssr', 'route': 'ssr', 'active': false}
                ];
                return getTabs(tabData, route);
            }

            function getTabStatistics(route) {
                var tabData = [
                    {'heading': 'global.menu.trafficOriginDestiny', 'route': 'trafficOriginDestiny', 'active': false},
                    {'heading': 'global.menu.trafficByStages', 'route': 'trafficByStages', 'active': false}
                ];
                return getTabs(tabData, route);
            }

            function getTabPassagesTransaction(route) {
                var tabData = [
                    {'heading': 'global.menu.transactionsTab.transactionByBranch', 'route': 'passagesBranchTransaction', 'active': false},
                    {'heading': 'global.menu.transactionsTab.transactionByUser', 'route': 'passagesUserTransaction', 'active': false}/*,
                    {'heading': 'global.menu.transactionsTab.transactionByChannelExternal', 'route': 'passagesChannelTransaction', 'active': false}*/
                ];
                return getTabs(tabData, route);
            }

            function getTabLuggageTransaction(route) {
                var tabData = [
                    {'heading': 'global.menu.transactionsTab.transactionByBranch', 'route': 'luggageBranchTransaction', 'active': false},
                    {'heading': 'global.menu.transactionsTab.transactionByUser', 'route': 'luggageUserTransaction', 'active': false}
                ];
                return getTabs(tabData, route);
            }

            function getTabSsrTransaction(route) {
                var tabData = [
                    {'heading': 'global.menu.transactionsTab.transactionByBranch', 'route': 'ssrBranchTransaction', 'active': false},
                    {'heading': 'global.menu.transactionsTab.transactionByUser', 'route': 'ssrUserTransaction', 'active': false}
                ];
                return getTabs(tabData, route);
            }

            function getTabCargoTransaction(route) {
                var tabData = [
                    {'heading': 'global.menu.transactionsTab.transactionByRegion', 'route': 'cargoRegionTransaction', 'active': false},
                    {'heading': 'global.menu.transactionsTab.transactionByBranch', 'route': 'cargoBranchTransaction', 'active': false},
                    {'heading': 'global.menu.transactionsTab.transactionByUser', 'route': 'cargoUserTransaction', 'active': false},
                    {'heading': 'global.menu.transactionsTab.forChargingGuidesPayable', 'route': 'forChargingGuidesPayable', 'active': false},
                    {'heading': 'global.menu.transactionsTab.incomeRoute', 'route': 'incomeRoute', 'active': false}
                ];
                return getTabs(tabData, route);
            }

            function getTabClassAvailability(route) {
                var tabData = [
                    {'heading': 'global.menu.classAvailabilityTab.flight', 'route': 'classAvailabilityByFlight', 'active': false},
                    {'heading': 'global.menu.classAvailabilityTab.connection', 'route': 'classAvailabilityByConnection', 'active': false}
                ];
                return getTabs(tabData, route);
            }

            function getTabPassengerList(route) {
                var tabData = [
                    {'heading': 'global.menu.passengerListTab.flight', 'route': 'passengerListByFlight', 'active': false},
                    {'heading': 'global.menu.passengerListTab.departure', 'route': 'passengerListByDeparture', 'active': false}
                ];
                return getTabs(tabData, route);
            }

            function getTabCargoOperationReport(route) {
                var tabData = [
                    {'heading': 'global.menu.cargoOperationReportTab.embarkation', 'route': 'embarkation', 'active': false},
                    {'heading': 'global.menu.cargoOperationReportTab.disembarkation', 'route': 'disembarkation', 'active': false},
                    {'heading': 'global.menu.cargoOperationReportTab.transference', 'route': 'transference', 'active': false},
                    {'heading': 'global.menu.cargoOperationReportTab.depot', 'route': 'depot', 'active': false}
                ];
                return getTabs(tabData, route);
            }

            function getTabCargoReceivedReport(route) {
                var tabData = [
                    {'heading': 'global.menu.cargoReceivedReportTab.office', 'route': 'cargoReceivedOffice', 'active': false},
                    {'heading': 'global.menu.cargoReceivedReportTab.region', 'route': 'cargoReceivedRegion', 'active': false},
                    {'heading': 'global.menu.cargoReceivedReportTab.destinations', 'route': 'cargoReceivedDestinations', 'active': false},
                    {'heading': 'global.menu.cargoReceivedReportTab.comingStock', 'route': 'cargoComingStock', 'active': false},
                    {'heading': 'global.menu.cargoReceivedReportTab.notDelivered', 'route': 'cargoNotDelivered', 'active': false},
                    {'heading': 'global.menu.cargoReceivedReportTab.consigneePhone', 'route': 'consigneePhone', 'active': false},
                    {'heading': 'global.menu.cargoReceivedReportTab.low', 'route': 'cargoLow', 'active': false},
                    {'heading': 'global.menu.cargoReceivedReportTab.annulment', 'route': 'cargoAnnulment', 'active': false},
                    {'heading': 'global.menu.cargoReceivedReportTab.refund', 'route': 'cargoRefund', 'active': false},
                    {'heading': 'global.menu.cargoReceivedReportTab.cargoDelivered', 'route': 'cargoDelivered', 'active': false}
                ];
                return getTabs(tabData, route);
            }

            function getTabLevelOfSalesReservations(route) {
                var tabData = [
                    {'heading': 'global.menu.levelOfSalesReservationsTab.flightAvailability', 'route': 'flightAvailability', 'active': false}
                ];
                return getTabs(tabData, route);
            }

            function getTabReprint(route) {
                var tabData = [
                    {'heading': 'global.menu.reprintTab.reprintByCode', 'route': 'reprint', 'active': false},
                    {'heading': 'global.menu.reprintTab.reprintBackup', 'route': 'reprintBackup', 'active': false}
                ];
                return getTabs(tabData, route);
            }

            function getTabCustomerCorporateReport(route) {
                var tabData = [
                    {'heading': 'global.menu.customerCorporateReport.customerCorporateOperations', 'route': 'customerCorporateOperations', 'active': false},
                    {'heading': 'global.menu.customerCorporateReport.ownOperations', 'route': 'ownOperations', 'active': false},
                    {'heading': 'global.menu.customerCorporateReport.reportKardex', 'route': 'reportKardex', 'active': false}
                ];
                return getTabs(tabData, route);
            }

            function getTabProduction(route) {
                var tabData = [
                    {'heading': 'global.menu.production.productionByFlights', 'route': 'productionByFlights', 'active': false},
                    {'heading': 'global.menu.production.flown', 'route': 'flown', 'active': false},
                    {'heading': 'global.menu.production.notFlown', 'route': 'notFlown', 'active': false}
                ];
                return getTabs(tabData, route);
            }

            function getTabPassages(route) {
                var tabData = [
                    {'heading': 'global.menu.reportPassages.postCheckInPassageAnnulment', 'route': 'postCheckInPassageAnnulment', 'active': false},
                    {'heading': 'global.menu.reportPassages.postCheckInAnnulment', 'route': 'postCheckInAnnulment', 'active': false},
                    {'heading': 'global.menu.reportPassages.airportTax', 'route': 'airportTax', 'active': false}
                ];
                return getTabs(tabData, route);
            }

            function getTabAuditRegistration(route) {
                var tabData = [
                    {'heading': 'global.menu.auditRegistration.flightTracking', 'route': 'flightTracking', 'active': false},
                    {'heading': 'global.menu.auditRegistration.revenueTracking', 'route': 'revenueTracking', 'active': false}
                ];
                return getTabs(tabData, route);
            }

            function getTabPromotion(route) {
                var tabData = [
                    {'heading': 'global.menu.promotionTab.one', 'route': 'one', 'active': false},
                    {'heading': 'global.menu.promotionTab.all', 'route': 'all', 'active': false}
                ];
                return getTabs(tabData, route);
            }
        }]);
})();
